module.exports = __webpack_public_path__ + "SourceSansPro-Regular.76e422402aa489a1240b.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-Regular.ttf
// module id = ../../../../../src/assets/customfonts/SourceSansPro-Regular.ttf
// module chunks = styles